<template>
    <div class="modal fade" :id="target" tabindex="-1" role="dialog" aria-labelledby="modal-label" aria-hidden="true">
        <div class="modal-dialog" :class="sizeClass" role="document">
            <div class="modal-content">
                <div class="modal-header d-flex">
                    <h5 class="modal-title flex-grow-1" id="modal-label">{{modalTitle}}</h5>

                    <button type="button" class="close"  @click="close" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div v-if="hasBody" class="modal-body">
                    <slot name="body"></slot>
                </div>
                <div v-if="hasSlot('footer')" class="modal-footer">
                    <slot name="footer">
                        <button type="button" class="btn btn-secondary" @click="close">
                            {{Lang.get('messages.cancel')}}
                        </button>
                        <button type="button" class="btn btn-primary" @click="confirm">
                            {{Lang.get('messages.confirm')}}
                        </button>
                    </slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            title: {
                type: String
            },

            target: {
                type: String,
                required: true
            },

            size: {
                validator: function (value) {
                    // The value must match one of these strings
                    return ['xl', 'lg', 'sm'].indexOf(value) !== -1
                }
            }
        },

        data() {
            return {
                modalTitle: this.title
            }
        },

        computed: {
            sizeClass(){
                return this.size ? `modal-${this.size}` : '';
            },

            hasFooter() {
                return !!this.$slots.footer;
            },

            hasBody() {
                return this.hasSlot("body");
            }
        },

        methods: {
            hasSlot(name = "default") {
                return !!this.$slots[name] || !!this.$scopedSlots[name];
            },

            open(title = null) {
                if (title) {
                    this.modalTitle = title;
                }

                $(`#${this.target}`).modal("show");
            },

            close() {
                $(`#${this.target}`).modal("hide");
            },

            confirm() {
                this.$emit("confirm");
            }
        }
    };

</script>

<style>
</style>
